<template>
  <div class="order">
    <router-view @gotoOrder="gotoOrder"></router-view>
  </div>
</template>

<script>
export default {
  name: "order",
  components: {
    
  },
  data(){
    return {
      
    }
  },
  methods: {
    gotoOrder : function(indexhead){
      this.$emit('changeindexhead',indexhead)
    },
  },
  mounted : function(){
    
  },
  created:function(){
    
  }
};
</script>

<style scoped lang="less">
</style>
